import React, { useContext } from 'react'
import { Cart } from 'chemistry'
import { TranslateContext } from 'client/common/translator'

const AddToCartButton = ({ onCartClick, addBundleToCartHref }) => {
  const t = useContext(TranslateContext)
  return (
    <a className='bundle-add-to-cart-button' href={addBundleToCartHref} onClick={onCartClick}>
      <span>{t('lister.bundle.add_to_cart')}</span>
      <Cart boxSize='20px' color='white' />
    </a>
  )
}

export default AddToCartButton
